var stickObject = {
    "playerGoalieSticks": [
        {
            "SKU": "688698552195",
            "VariantID": "49291142234430"
        },{
            "SKU": "688698403497",
            "VariantID": "42997152678126"
        },{
            "SKU": "688698552188",
            "VariantID": "49291141644606"
        },{
            "SKU": "688698403503",
            "VariantID": "42997152710894"
        },{
            "SKU": "688698403510",
            "VariantID": "42997152743662"
        },{
            "SKU": "688698403527",
            "VariantID": "42997152776430"
        },{
            "SKU": "688698403534",
            "VariantID": "42997152841966"
        },{
            "SKU": "688698403541",
            "VariantID": "42997152874734"
        },{
            "SKU": "688698403558",
            "VariantID": "42997152907502"
        },{
            "SKU": "688698403565",
            "VariantID": "42997152940270"
        },{
            "SKU": "688698403572",
            "VariantID": "42997152973038"
        },{
            "SKU": "688698402148",
            "VariantID": "42997152514286"
        },{
            "SKU": "688698402155",
            "VariantID": "42997152579822"
        },{
            "SKU": "688698402162",
            "VariantID": "42997152612590"
        },{
            "SKU": "688698403589",
            "VariantID": "49291121623358"
        },{
            "SKU": "688698403596",
            "VariantID": "49291121885502"
        },{
            "SKU": "688698403602",
            "VariantID": "49291121787198"
        },{
            "SKU": "688698342093",
            "VariantID": "42997147730158"
        },{
            "SKU": "688698402070",
            "VariantID": "42997152481518"
        },{
            "SKU": "688698342086",
            "VariantID": "42997147697390"
        },{
            "SKU": "688698402049",
            "VariantID": "42997152350446"
        },{
            "SKU": "688698402056",
            "VariantID": "42997152415982"
        },{
            "SKU": "688698465945",
            "VariantID": "42997157593326"
        },{
            "SKU": "688698465938",
            "VariantID": "42997157560558"
        },{
            "SKU": "688698423495",
            "VariantID": "49291121983806"
        },{
            "SKU": "688698423501",
            "VariantID": "49291122213182"
        },{
            "SKU": "688698423518",
            "VariantID": "49291122147646"
        },{
            "SKU": "688698424478",
            "VariantID": "42997153890542"
        },{
            "SKU": "688698424461",
            "VariantID": "42997153857774"
        },{
            "SKU": "688698424485",
            "VariantID": "42997153923310"
        },{
            "SKU": "688698507157",
            "VariantID": "42997163524334"
        },{
            "SKU": "688698507140",
            "VariantID": "49291125195070"
        },{
            "SKU": "688698507133",
            "VariantID": "42997163458798"
        },{
            "SKU": "688698507126",
            "VariantID": "49291124834622"
        },{
            "SKU": "688698483369",
            "VariantID": "49291123130686"
        },{
            "SKU": "688698483376",
            "VariantID": "49291123327294"
        },{
            "SKU": "688698483994",
            "VariantID": "49291123032382"
        },{
            "SKU": "688698484007",
            "VariantID": "49291123458366"
        },{
            "SKU": "688698503999",
            "VariantID": "49291123556670"
        },{
            "SKU": "688698504002",
            "VariantID": "49291123884350"
        },{
            "SKU": "688698504019",
            "VariantID": "49291124015422"
        },{
            "SKU": "688698554083",
            "VariantID": "49291127128382"
        },{
            "SKU": "688698554090",
            "VariantID": "49291127193918"
        },{
            "SKU": "688698552164",
            "VariantID": "49291142103358"
        },{
            "SKU": "688698552171",
            "VariantID": "49291141775678"
        },{
           "SKU":"688698616125",
           "VariantID":"49291282809150"
        },
        {
           "SKU":"688698616156",
           "VariantID":"49291282776382"
        },
        {
           "SKU":"688698616132",
           "VariantID":"49291282743614"
        },
        {
           "SKU":"688698616149",
           "VariantID":"49291282645310"
        },
      {
           "SKU":"688698614237",
           "VariantID":"49291303846206"
        },
      {
           "SKU":"688698614220",
           "VariantID":"49291303813438"
        },
      {
           "SKU":"688698614244",
           "VariantID":"49291303977278"
        },
      {
           "SKU":"688698614251",
           "VariantID":"49291303944510"
        },
        {
           "SKU":"688698621334",
           "VariantID":"49291338481982"
        },
        {
           "SKU":"688698621341",
           "VariantID":"49291339727166"
        },
        {
           "SKU":"688698621358",
           "VariantID":"49291339858238"
        },
        {
           "SKU":"688698621365",
           "VariantID":"49291338416446"
        },
        {
           "SKU":"688698403589",
           "VariantID":"49291121623358"
        },
        {
           "SKU":"688698403596",
           "VariantID":"49291121885502"
        },
        {
           "SKU":"688698403602",
           "VariantID":"49291121787198"
        },
        {
            "SKU":"688698648607",
            "VariantID":"49291385340222"
         },
         {
            "SKU":"688698648621",
            "VariantID":"49291385241918"
         },
         {
            "SKU":"688698648614",
            "VariantID":"49291385209150"
         },
         {
            "SKU":"688698648591",
            "VariantID":"49291385274686"
         },
       {
           "SKU":"688698684230",
           "VariantID":"49291455758654"
        },
      {
           "SKU":"688698705935",
           "VariantID":"49291455824190"
        },
      {
           "SKU":"688698684247",
           "VariantID":"49291455725886"
        },
      {
           "SKU":"688698673050",
           "VariantID":"49949821272382"
        },
      {
           "SKU":"688698673043",
           "VariantID":"49949813080382"
        },
      {
           "SKU":"688698673067",
           "VariantID":"49949821993278"
        },
      {
           "SKU":"688698673036",
           "VariantID":"49949799481662"
        },
      {
           "SKU":"688698763980",
           "VariantID":"51642711671154"
        },
      {
           "SKU":"688698763966",
           "VariantID":"51642711572850"
        },
      {
           "SKU":"688698763959",
           "VariantID":"51642711703922"
        },
      {
           "SKU":"688698763973",
           "VariantID":"51642711540082"
        },
      {
           "SKU":"688698763997",
           "VariantID":"51642711736690"
        },
      {
           "SKU":"688698749021",
           "VariantID":"52315395162482"
        },
      {
           "SKU":"688698749045",
           "VariantID":"52315397947762"
        },
      {
           "SKU":"688698749014",
           "VariantID":"52315395129714"
        },
      {
           "SKU":"688698749038",
           "VariantID":"52315397980530"
        },
      {
           "SKU":"688698806427",
           "VariantID":"52315398013298"
        },
      {
           "SKU":"688698750393",
           "VariantID":"52324212146546"
        },
      {
           "SKU":"688698705935",
           "VariantID":"52324212081010"
        },
      {
           "SKU":"688698750416",
           "VariantID":"52324212179314"
        },
      {
           "SKU":"688698750409",
           "VariantID":"52324212113778"
        },
      {
           "SKU":"688698684247",
           "VariantID":"52324212277618"
        },
      {
           "SKU":"688698752717",
           "VariantID":"52324212244850"
        },
      {
           "SKU":"688698750423",
           "VariantID":"52324212310386"
        },
       {
           "SKU":"688698684230",
           "VariantID":"52324212212082"
        },
      {
           "SKU":"688698795165",
           "VariantID":"52324212343154"
        },
       {
           "SKU":"688698768282",
           "VariantID":"52323955802482"
        },
      {
           "SKU":"688698768305",
           "VariantID":"52323955868018"
        },
      {
           "SKU":"688698768299",
           "VariantID":"52323955835250"
        },
      {
           "SKU":"688698768275",
           "VariantID":"52323955638642"
        },
      {
           "SKU":"688698768244",
           "VariantID":"52323955671410"
        },
      {
           "SKU":"688698768268",
           "VariantID":"52323955704178"
        },
       {
           "SKU":"688698768251",
           "VariantID":"52323955736946"
        },
      {
           "SKU":"688698803532",
           "VariantID":"52334798012786"
        },
      {
           "SKU":"688698803549",
           "VariantID":"52334798045554"
        },
       {
           "SKU":"688698806434",
           "VariantID":"52334798111090"
        },
      {
           "SKU":"688698803556",
           "VariantID":"52334798078322"
        },
       {
           "SKU":"688698803563",
           "VariantID":"52334798143858"
        },
      
     
    ],
    "quickTurnSticks": [
        {
            "SKU": "ULTRAS_LP_JR5",
            "VariantID": "49291142136126"
        },
        {
            "SKU": "ULTRAS_LP_JR4",
            "VariantID": "49291142267198"
        },
        {
            "SKU": "HYPERL_LP_SR",
            "VariantID": "49291142529342"
        },
        {
            "SKU": "HYPERL_LP_INT",
            "VariantID": "49291142594878"
        },
        {
            "SKU": "HYPERL_LP_JR5",
            "VariantID": "49291142660414"
        },
        {
            "SKU": "HYPERL_LP_JR4",
            "VariantID": "49291142693182"
        },
        {
            "SKU": "SYNCN_LP_SR",
            "VariantID": "49291142955326"
        },
        {
            "SKU": "SYNCN_LP_INT",
            "VariantID": "49291143053630"
        },
        {
            "SKU": "SYNCN_LP_JR5",
            "VariantID": "49291142988094"
        },
        {
            "SKU": "SYNCN_LP_JR4",
            "VariantID": "49291143119166"
        },
        {
          "SKU": "ULTRAS_LP_SR",
          "VariantID": "49291140792638"
        },
        {
          "SKU": "ULTRAS_LP_INT",
          "VariantID": "49291140333886"
        },
        {
          "SKU": "HYPERL2_LP_SR",
          "VariantID": "49291343724862"
        },
        {
          "SKU": "HYPERL2_LP_INT",
          "VariantID": "49291343790398"
        },
        {
          "SKU": "HYPERL2_LP_JR5",
          "VariantID": "49291343823166"
        },
        {
          "SKU": "HYPERL2_LP_JR4",
          "VariantID": "49291343855934"
        },
        {
            "SKU": "PROTOR_LP_INT",
            "VariantID": "49291385405758"
          },
          {
            "SKU": "PROTOR_LP_JR4",
            "VariantID": "49291385700670"
          },
          {
            "SKU": "PROTOR_LP_JR5",
            "VariantID": "49291385438526"
          },
          {
            "SKU": "PROTOR_LP_SR",
            "VariantID": "49291385372990"
          }
    ]
};

var bladeObject = {
    "blades": [
        {
        "SKU": "688698463569",
        "VariantID": "43639290954046"
      },
      {
        "SKU": "688698463576",
        "VariantID": "43639280402750"
      },
      {
        "SKU": "688698512878",
        "VariantID": "43639283056958"
      },
      {
        "SKU": "688698627046",
        "VariantID": "44600494620990"
      },
      {
        "SKU": "688698627039",
        "VariantID": "44600473715006"
      }
    ]
};

var skateObject = {
    "skates": [
        {
            "SKU": "688698582178",
            "VariantID": "49291127587134"
        },
        {
            "SKU":"688698582154",
            "VariantID":"49291127619902"
        },
        {
            "SKU":"688698582215",
            "VariantID":"49291128242494"
        }, 
        {
            "SKU":"688698582147",
            "VariantID":"49291127488830"
        },
        {
            "SKU":"688698582208",
            "VariantID":"49291128144190"
        },
        {
            "SKU":"688698582192",
            "VariantID":"49291127980350"
        },
        {
            "SKU":"688698582185",
            "VariantID":"49291127816510"
        },
        {
            "SKU":"688698582161",
            "VariantID":"49291127947582"
        },
        {
            "SKU":"688698512861",
            "VariantID":"49291126112574"
        },
        {
            "SKU":"688698512854",
            "VariantID":"49291126276414"
        },
        {
            "SKU":"688698512847",
            "VariantID":"49291126079806"
        },
        {
            "SKU":"688698512830",
            "VariantID":"49291125915966"
        },
        {
            "SKU":"688698512823",
            "VariantID":"49291125653822"
        },
        {
            "SKU":"688698512816",
            "VariantID":"49291125621054"
        },
        {
            "SKU":"688698512809",
            "VariantID":"49291125522750"
        },
       {
            "SKU":"688698512793",
            "VariantID":"49291125326142"
        },
       {
            "SKU":"688698512113",
            "VariantID":"42997164474606"
        },
        {
            "SKU":"688698511796",
            "VariantID":"42997164179694"
        },
        {
            "SKU":"688698511789",
            "VariantID":"42997164146926"
        },
        {
            "SKU":"688698390636",
            "VariantID":"42997151105262"
        },
      {
            "SKU":"688698595666",
            "VariantID":"49291304108350"
        },
      {
            "SKU":"688698595680",
            "VariantID":"49291304534334"
        },
      {
            "SKU":"688698595673",
            "VariantID":"49291304075582"
        },
      {
            "SKU":"688698595659",
            "VariantID":"49291304141118"
        }
    ],
    "blades": [
    {
        "BladeType": "LS Pulse Ti",
        "SKU": "688698463569",
        "VariantID": "43639290954046"
      },
      {
        "BladeType": "LS Pulse TI",
        "SKU": "688698463569",
        "VariantID": "43639290954046"
      },
      {
        "BladeType": "LS Pulse",
        "SKU": "688698463576",
        "VariantID": "43639280402750"
      },
      {
        "BladeType": "LS CarbonLite",
        "SKU": "688698512878",
        "VariantID": "43639283056958"
      },
      {
        "BladeType": "FLY-TI",
        "SKU": "688698627039",
        "VariantID": "44600473715006"
      },
      {
        "BladeType": "FLY-X",
        "SKU": "688698627046",
        "VariantID": "44600494620990"
      }
    ]
};
// Initialize myBauer stick object
window.addEventListener("DOMContentLoaded", function() {
    stickObject;
    bladeObject;
    skateObject;
})